import { classnames } from '@bydesign-ui/utils';
import React, { useContext, useMemo } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { StepsContext } from './context/steps';

var noop = function noop() {
  return void 0;
};

export function Step(props) {
  var _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      content = props.content,
      title = props.title,
      className = props.className,
      description = props.description,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? noop : _props$onClick;

  var _useContext = useContext(StepsContext),
      current = _useContext.current,
      stepStatus = _useContext.status;

  var status = useMemo(function () {
    if (current > index) {
      if (current === index + 1 && stepStatus === 'error') {
        return 'next-error';
      }

      return 'finish';
    } else if (current < index) {
      return 'wait';
    }

    return stepStatus || 'process';
  }, [stepStatus, current, index]);
  var cls = classnames(usePrefixCls('steps-step', {
    status: status
  }), className);
  return React.createElement("div", {
    className: cls,
    onClick: onClick
  }, React.createElement("div", {
    className: "step-tail"
  }), React.createElement("div", {
    className: "step-head"
  }, content), React.createElement("div", {
    className: "step-content"
  }, React.createElement("div", {
    className: "step-title"
  }, title), React.createElement("div", {
    className: "step-description"
  }, description)));
}